export default function Title() {
  return (
    <span>
      #<span className="color-maroon">S</span>
      <span className="color-orange">t</span>
      <span className="color-yellow">a</span>
      <span className="color-green">r</span>
      tupScapeSL
    </span>
  );
}
